import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../views/Home.vue'
import Invoice from '../views/Invoice.vue'
import Receipt from '../views/Receipt.vue'
import MyInvoices from '../views/MyInvoices.vue'

import Error404 from '../views/404.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    alias: 'home',
    component: Home
  },
  {
    path: '/minhas-faturas',
    name: 'myInvoices',
    component: MyInvoices
  },
  {
    path: '/:id',
    name: 'invoice',
    component: Invoice,
    props: true
  },
  {
    path: '/recibo/:id',
    name: 'receipt',
    component: Receipt,
    props: true
  },
  {
    path: '/*',
    name: '404',
    component: Error404
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
